import React from 'react'
import { ScrollView, StyleSheet, View, Linking } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Header, Screen, Text } from '@components'
import { useLanguage } from '@context'
import { useFooterPageBack } from './useFooterPageBack'

export const JoinUs: React.FC = () => {
  const theme = useTheme()
  const { t } = useLanguage()
  const onPressBack = useFooterPageBack()
  const styles = getStyles(theme)

  return (
    <Screen>
      <Header
        title={t('webFooter.joinUs')}
        iconLeft="arrowBack"
        onPressLeft={onPressBack}
      />
      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <View style={styles.section}>
          <Text type="body" color={theme.colors.secondary}>
            {t('joinUs.description')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('joinUs.whyJoin')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('joinUs.whyJoinContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('joinUs.positions')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('joinUs.positionsContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('joinUs.apply')}
          </Text>
          <Text
            type="body"
            color={theme.colors.primary}
            onPress={() => Linking.openURL(`mailto:${t('joinUs.applyEmail')}`)}
          >
            {t('joinUs.applyEmail')}
          </Text>
        </View>
      </ScrollView>
    </Screen>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    content: {
      flex: 1,
      paddingHorizontal: theme.spacing.xl,
    },
    section: {
      marginBottom: theme.spacing.xxl,
    },
    sectionTitle: {
      marginBottom: theme.spacing.sm,
    },
  })
